<template>
  <div id="mobileNav">
    <div class="is-drilldown">
      <ul class="vertical menu drilldown"
          data-drilldown=""
          role="tree"
          aria-multiselectable="false">
        <NavigationMobileItem v-for="item in $options.items"
                        :aria-label="item.text"
                        :key="item.path"
                        :text="item.text"
                        :path="item.path"
                        :has-sub-items="item.subItems !== undefined">
          <template v-if="item.subItems">
            <NavigationMobileItemSubmenu>
              <NavigationMobileItem v-for="subItem in item.subItems"
                              :key="subItem.path"
                              :text="subItem.text"
                              :path="subItem.path"
                              :is-sub-menu-item="true"/>
            </NavigationMobileItemSubmenu>
          </template>
        </NavigationMobileItem>
      </ul>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import NavigationMobileItem from '@/components/navigation/mobile/NavigationMobileItem';
import NavigationMobileItemSubmenu from '@/components/navigation/mobile/NavigationMobileItemSubmenu';

export default {
  name: 'TheNavigationMobile',
  components: { NavigationMobileItemSubmenu, NavigationMobileItem },
  created () {
    const allRoutes = router.options.routes;
    this.$options.items = [];
    for (const route of allRoutes) {
      const item = {
        text: route.name,
        path: route.path
      };
      if ('subRoutes' in route) {
        item.subItems = [];
        if (route.name !== 'Focused on You') {
          item.subItems.push({
            text: 'Home',
            path: route.path
          });
        }
        for (const subRoute of route.subRoutes) {
          item.subItems.push({
            text: subRoute.name,
            path: subRoute.path
          });
        }
      }
      this.$options.items.push(item);
    }
  }
};
</script>
